/**
 * Dispatch Board Route
 *
 * Route configuration for the dispatch board page.
 * Path: /dispatch-board (matches sidebar navigation)
 */

import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { DispatchBoard } from '@/pages/DispatchBoard';

const dispatchSearchSchema = z.object({
  view: z.enum(['grid', 'map']).optional(),
  range: z.enum(['daily', 'weekly']).optional(),
  panel: z.enum([
    'unscheduled', 'unassigned', 'openWithPo',
    'partiallyCompleted', 'paused', 'markedForFollowUp',
  ]).optional(),
  date: z.string().optional(),
});

export type DispatchSearch = z.infer<typeof dispatchSearchSchema>;

export const Route = createFileRoute('/_authenticated/dispatch-board')({
  validateSearch: dispatchSearchSchema,
  component: DispatchBoard,
});
